<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">Acionamento remoto da mola</h4>
      </div>
      <div>

        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input
          name="vm"
          label="Vending machine">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a vending machine"
                      v-model="machine">
            <el-option v-for="option in machines"
                        class=""
                        :value="option.id"
                        :label="option.location"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input
          v-if="machine"
          name="shelf"
          label="Prateleira">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a prateleira"
                      v-model="shelf">
            <el-option v-for="option in shelves"
                        class=""
                        :value="option.id"
                        :label="String.fromCharCode(option.position + 65)"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input
          v-if="shelf"
          name="coil"
          label="Mola">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a mola"
                      @input="objCoil(coil)"
                      v-model="coil">
            <el-option v-for="(option, i) in coils"
                        class=""
                        :value="(option.position + 1)"
                        :label="(option.position + 1)"
                        :key="i">
            </el-option>
          </el-select>
        </fg-input>
        <div v-if="showProduct">
          <div v-if="act[0].product_name">
            <p><b>Produto :</b> {{act[0].product_name}}</p>
            <p v-if="act[0].product_variant"><b>Variação :</b> {{act[0].product_variant}}</p>
            <p v-if="act[0].amount == 0"><b>Quantidade insuficiente</b> {{act[0].product_variant}}</p>
          </div>
          <div v-else>
            <p><b>Mola sem produto</b> {{act[0].product_name}}</p>
          </div>
        </div>
      </div>
    </card>
    <card>
      <div>
        <button type="submit"
          @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Atuar remotamente</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option } from "element-ui";
import swal from "sweetalert2";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      machines: [],
      machine: '',
      shelves: [],
      companyList: [],
      company: '',
      shelf: '',
      coils: [],
      coil: '',
      act: [],
      showProduct: false
    };
  },
  mounted () {
    this.$watch('machine', ()=>{
      this.getShelf()
    })
    this.$watch('shelf', ()=>{
      this.showProduct = false
      this.getCoil()
    })
    this.$watch('coil', ()=>{
      console.log('coil', this.coil)
    })
    this.$watch('company',()=>{
      this.machines = []
      this.$store.dispatch('general/flag', {id: this.company}).then(()=>{
        this.getData(this.company)
      })
    })
    this.getListCompany()
    var ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) { 
      this.getData(ciaID)
    } else {
      this.getData()
    }
  },
  computed: {
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    getData (ciaID) {
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).then(resp => {

        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "V05"){
            if (el.active === true) {
              return el
            }
          }
        })
        var x = []
        this.machines = resp.map(el =>{
          return y.filter(ar =>{
            if (ar.vm == el.id) {
              x.push(el)
            }
          })

        })
        console.log('x',x)
        this.machines = x
      })
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    getShelf () {
      this.$store.dispatch('shelves/listSort', {sort: "?vm=" + this.machine}).then (resp =>{
        this.shelves = resp
      })
    },
    objCoil (data) {
      this.showProduct = false
      console.log('data', data-1)
      this.act = this.coils.filter(v =>{
        if (v.position == data-1){
          return v
        }
        setTimeout(() => {
          if (this.act.length > 0) {
            this.showProduct = true
          }
        }, 200);
      // 
      })
      console.log('act', this.act)
    },
    getCoil () {
      this.$store.dispatch('coils/listSort', {sort: '?shelf='+ this.shelf})
        .then(resp => {
          this.coils = resp.results.filter(v =>{
            if (v.active) {
              return v
            }
          })
          this.coils = this.coils.sort((a,b) => (Number(a.position) > Number(b.position)) ? 1 : ((Number(b.position) > Number(a.position)) ? -1 : 0))
          
          // this.showProduct = true
        })
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Senha alterada!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Preencha todos os dados antes!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    notifyError2() {
      this.$notify({
        message: "Erro</br>Quantidade insuficiente!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    async validate () {
      if (this.act.length > 0) {
        if (this.act[0].amount == 0) {
          this.notifyError2()
        } else {
          var data = {
            lift: true,
              coils: [
                {
                  id: (this.coil - 1),
                  shelf: this.shelf,
                  quantity: 1
                }
              ]

          }
          var payload = {data: data, id: this.machine}
          swal.fire({
            title: 'Atenção!',
            text: `Você está prestes a acionar uma mola remotamente, fazendo a retirada  de apenas UM item 
            especificado anteriormente.`,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: 'Sim, acionar!',  
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
              return this.$store.dispatch('machines/remoteCoil', payload)
                .then(response => {
                  if (response.status !== 200) {
                    throw new Error(response.statusText)
                  }
                })
                .catch(error => {
                  swal.showValidationMessage(
                    `Falha na comunicação: ${error}`
                  )
                })
            },
            allowOutsideClick: () => !swal.isLoading()
          }).then((result) => {
            if (result.value) {
              swal.fire({
                title: `Item foi despejado.`,
              })
            }
          })
        }
      } else {
        this.notifyError()
    }
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
